import { render, staticRenderFns } from "./areaMyChecklistProjects.vue?vue&type=template&id=798fd1d9&scoped=true"
import script from "./areaMyChecklistProjects.vue?vue&type=script&lang=js"
export * from "./areaMyChecklistProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798fd1d9",
  null
  
)

export default component.exports